import PagePath from "../components/PagePath";
import PageTitle from "../ui/PageTitle";

export default function PageLayout({
  title = "",
  subTitle = "",
  breadCrumbs = [],
  children,
  style = { hasCardBg: true, pageLayoutClassName: "pt-4" },
  loading = false
}) {
  return (
    <div className={style?.pageLayoutClassName ?? "pt-4"}>
      <PageTitle title={title} />
      <PagePath title={title} subTitle={subTitle} breadCrumbs={breadCrumbs} loading={loading} />
      <div className={`row ${style?.contentContainerClassName ?? "pt-4"}`}>
        <div className="col">
          <div className={`card border-0 ${style?.hasCardBg ? "" : "bg-transparent"}`}>
            <div className={`card-body ${style?.cardBodyClass ?? ""}`}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
